import { Name } from '@ori-events/open-login';
import type { FC, MouseEvent, PropsWithChildren } from 'react';
import { useCallback, useEffect, useMemo } from 'react';

import { SSO_IDENTITY_AD_LOGIN_PATH, SSO_IDENTITY_LOGIN_PATH } from '../../constants';
import { Provider } from '../../contexts';
import { goToPage } from '../../utils';

export const LoginProvider: FC<PropsWithChildren> = ({ children }) => {
  const doLogin = useCallback((event?: MouseEvent) => {
    // Ctrl or Cmd key is pressed, redirect to AD login
    if (Boolean(event?.ctrlKey) || event?.metaKey) {
      goToPage(SSO_IDENTITY_AD_LOGIN_PATH);

      return;
    }

    goToPage(SSO_IDENTITY_LOGIN_PATH);
  }, []);
  const onLogin = useCallback(() => {
    doLogin();
  }, [doLogin]);

  useEffect(() => {
    window.addEventListener(Name, onLogin);

    return () => {
      window.removeEventListener(Name, onLogin);
    };
  }, [onLogin]);

  return <Provider value={useMemo(() => ({ doLogin }), [doLogin])}>{children}</Provider>;
};
